import React, { useContext, useState, memo } from 'react';
import Traductor from '../Traductor';
import { VehiclesContext } from '../../contexts/VehiclesContext';
import Button from '../bronson/Button';
import { withCookies } from 'react-cookie';
import { formatPrice } from '../../js/components/shared/vehicleFunctions';
import Globals from '../../Globals';

const VehicleDirectPurchaseModality = ({
    history,
    vehicleParent,
    loadingRequest,
    disabled,
}) => {
    const t = new Traductor();
    const { setSelectedVehicle } = useContext(VehiclesContext);
    const [vehicle] = useState(vehicleParent);

    const optionsBtnComprar = {
        class: 'c-btn--full u-mt-small',
        text: t.getTraduction('Buy'),
        btnTypes: ['primary'],
        disabled: loadingRequest || disabled,
    };

    const handleClickcompraDirecta = () => {
        setSelectedVehicle(vehicle);
        history.push(Globals.APPLICATION_PATH.DIRECT_PURCHASE);
    };

    return (
        <>
            <hr />
            <div className="o-layout">
                <div className="o-layout__item u-2/3">
                    <p className="rema-text-overflow--ellipsis u-mb-xsmall">
                        {t.getTraduction('DirectPurchase')}{' '}
                    </p>
                    <p className="u-h6 u-mb-none c-vehicle-buy-options__buy-price u-mb-none">
                        {formatPrice(vehicle.Price)}
                    </p>
                </div>
                <div className="o-layout__item u-1/3 u-p-none">
                    <Button
                        options={optionsBtnComprar}
                        onClick={handleClickcompraDirecta}
                    />
                </div>
            </div>
        </>
    );
};

export default memo(withCookies(VehicleDirectPurchaseModality));
